import styled from "styled-components";

const LocalesListItem = styled.div`
  border: none;
  width: 100%;
  background-color: transparent;
  padding: 5px 10px;
  box-sizing: border-box;

  &:hover {
    border-radius: 8px;
    background-color: rgba(0, 0, 0, 0.05);
    cursor: pointer;
  }
`;

export default LocalesListItem;
